// Shared document-mutation watcher. Several cc-* widgets (product-card
// dot indicators, wishlist icon sync, quick-add/GoKwik re-scan ping) each
// used to run their own `new MutationObserver(...).observe(document.
// documentElement, {childList:true, subtree:true})` — the broadest
// possible scope, independently re-triggered by every DOM change anywhere
// on the page (cart updates, GoKwik's own scans, any app's injected
// markup), each doing its own debounced full-page re-scan. One shared
// observer here replaces all of them: a single whole-document watch,
// fanning out to each listener's own debounce.
(function () {
  var listeners = [];

  function notify() {
    for (var i = 0; i < listeners.length; i++) listeners[i]();
  }

  new MutationObserver(notify).observe(document.documentElement, { childList: true, subtree: true });

  // Registers `fn` to run (debounced by `ms`, default 50) after any DOM
  // mutation anywhere on the page. Returns nothing — listeners live for
  // the page's lifetime, same as the observers this replaces.
  window.ccOnDomChange = function (fn, ms) {
    var t;
    listeners.push(function () {
      clearTimeout(t);
      t = setTimeout(fn, ms == null ? 50 : ms);
    });
  };
})();
